"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
const plc_1 = require("../../../plc");
const guid_1 = require("../../../common/src/guid");
const plcToken_1 = require("../plcToken");
var PlcInputOrder;
(function (PlcInputOrder) {
    PlcInputOrder[PlcInputOrder["default"] = 1] = "default";
    PlcInputOrder[PlcInputOrder["asc"] = 2] = "asc";
    PlcInputOrder[PlcInputOrder["desc"] = 3] = "desc";
})(PlcInputOrder = exports.PlcInputOrder || (exports.PlcInputOrder = {}));
class PlcRadioValue {
    constructor(value) {
        this.value = value;
        this.guid = guid_1.Guid.newGuid();
    }
}
exports.PlcRadioValue = PlcRadioValue;
let PlcComponent = class PlcComponent {
    constructor(_inaxPlc) {
        this._inaxPlc = _inaxPlc;
        this._defaultPlcOrder = [];
        this._sortedBy = 'default';
        this._sortDirection = PlcInputOrder.default;
        this.plcs = [];
        this.default = '(empty)';
        this.radioValues = [new PlcRadioValue('true'), new PlcRadioValue('false')];
    }
    ngOnInit() {
        //      this.load();
    }
    ngOnDestroy() {
        //      this.save();
    }
    addTextbox(plcGroup, plcAddress, plcId, plcWriteperm, addressType, defaultText, minval, maxval) {
        let plc = new plcToken_1.PlcTextToken(plcGroup, plcAddress, plcId, plcWriteperm, addressType, defaultText, minval, maxval);
        this._defaultPlcOrder.push(plc);
        this.sort();
        // console.log('added ' + plc.toString());
    }
    addButton(plcGroup, plcAddress, plcId, plcWriteperm, addressType, toggle, trueVal, falseVal, trueValMes, falseValMes) {
        let plc = new plcToken_1.PlcButtonToken(plcGroup, plcAddress, plcId, plcWriteperm, addressType, toggle, trueVal, falseVal, trueValMes, falseValMes);
        this._defaultPlcOrder.push(plc);
        this.sort();
        // console.log('added ' + plc.toString());
    }
    addCheckbox(plcGroup, plcAddress, plcId, plcWriteperm, addressType, trueVal, falseVal, trueValMes, falseValMes) {
        let plc = new plcToken_1.PlcCheckboxToken(plcGroup, plcAddress, plcId, plcWriteperm, addressType, trueVal, falseVal, trueValMes, falseValMes);
        this._defaultPlcOrder.push(plc);
        this.sort();
        // console.log('added ' + plc.toString());
    }
    addRadio(plcGroup, plcAddress, plcId, plcWriteperm, addressType, values) {
        let valueStrings = [];
        values.forEach((val) => { valueStrings.push(val.value); });
        let plc = new plcToken_1.PlcRadioToken(plcGroup, plcAddress, plcId, plcWriteperm, addressType, valueStrings);
        this._defaultPlcOrder.push(plc);
        this.sort();
        // console.log('added ' + plc.toString());
        // reset selection in control panel (or should we let it as it is?) 
        this.radioValues = [new PlcRadioValue('true'), new PlcRadioValue('false')];
    }
    addState(plcGroup, plcAddress, plcId, plcWriteperm, addressType, trueVal, falseVal, trueValMes, falseValMes, interval) {
        let plc = new plcToken_1.PlcStateToken(plcGroup, plcAddress, plcId, plcWriteperm, addressType, trueVal, falseVal, trueValMes, falseValMes, interval);
        this._defaultPlcOrder.push(plc);
        this.sort();
        // console.log('added ' + plc.toString());
    }
    removePlc(plc) {
        this._defaultPlcOrder.splice(this._defaultPlcOrder.indexOf(plc), 1);
        this.sort();
        // console.log('removed ' + plc);
    }
    addRadioValue() {
        this.radioValues.push(new PlcRadioValue(''));
    }
    changeRadioValue(item, value) {
        this.radioValues[this.radioValues.indexOf(item)].value = value;
    }
    removeRadioValue(prv) {
        this.radioValues.splice(this.radioValues.indexOf(prv), 1);
    }
    sortBy(column) {
        console.log('sort by ' + column);
        if (this._sortedBy === column) {
            if (this._sortDirection === PlcInputOrder.asc) {
                this._sortDirection = PlcInputOrder.desc;
                this.sort();
            }
            else {
                this._sortedBy = 'default';
                this._sortDirection = PlcInputOrder.default;
                this.plcs = this._defaultPlcOrder;
            }
        }
        else {
            this._sortDirection = PlcInputOrder.asc;
            this._sortedBy = column;
            this.sort();
        }
    }
    sort() {
        let c = this._sortedBy;
        let d = this._sortDirection;
        this.plcs = [];
        this._defaultPlcOrder.forEach(elem => {
            this.plcs.push(elem);
        });
        ;
        if (d === PlcInputOrder.asc) {
            this.plcs.sort((a, b) => { return (a[c] > b[c]) ? 1 : -1; }); // sort asc
        }
        else if (d === PlcInputOrder.desc) {
            this.plcs.sort((a, b) => { return (a[c] < b[c]) ? 1 : -1; }); // sort desc
        }
    }
    str2Plc(plcString) {
        let plcs = new Array();
        /* // implement after Tokens
        let plcStringArray = plcString.split('~~~SEPARATOR~~~');
        console.log(plcStringArray);
        for (let ps in plcStringArray) {
            let props = ps.split('~p~l~c~');
            // double check length
            if (props.length === 8) {
                let textInput = (props[5] === 'true');
                let plc = new PlcTextToken(props[0],props[1],props[2],props[3],props[4],textInput,props[6]);
                plcs.push(plc);
            }
            else {
                console.warn('invalid plcs' + props);
            }
        }*/
        return plcs;
    }
    save() {
        console.log('SAVING');
        let StringArray = new Array();
        this._defaultPlcOrder.forEach((plc) => {
            StringArray.push(plc.toString());
        });
        window.localStorage.setItem('plc-address-storage', StringArray.join('~~~SEPARATOR~~~'));
    }
    load() {
        console.log('LOADING');
        let plcs = window.localStorage.getItem('plc-address-storage');
        console.log(plcs);
        if (plcs !== null) {
            this._defaultPlcOrder = this.str2Plc(plcs);
            this.sort();
        }
    }
    logg(x) {
        console.log(x);
    }
};
PlcComponent = __decorate([
    core_1.Component({
        selector: 'plc',
        templateUrl: './@inax/plcUi/src/plc/plc.component.html',
        styleUrls: ['./@inax/plcUi/src/plc/plc.component.css']
    }),
    __metadata("design:paramtypes", [plc_1.InaxPlcService])
], PlcComponent);
exports.PlcComponent = PlcComponent;
